"use client";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import * as i from "@radix-ui/react-accordion";
import { cn as e } from "../../../utils/utils.mjs";
import "react";
import "../Tooltip/Tooltip.mjs";
import "../Text/Text.mjs";
import "../TextAreaInput/TextAreaInput.mjs";
import "../Input/Input.mjs";
import "tailwind-merge";
import "../Button/Button.mjs";
import "../Pill/Pill.mjs";
import "../Collapsible/Collapsible.mjs";
import "../IconButton/IconButton.mjs";
import "../Slider/Slider.mjs";
import "../Skeleton/Skeleton.mjs";
import "../Toast/Toast.mjs";
import "../Badge/Badge.mjs";
import "../../molecules/RadioGroup/RadioGroup.mjs";
import "../Dialog/Dialog.mjs";
import "../Divider/Divider.mjs";
import "../Tabs/Tabs.mjs";
import { Icon as c } from "../Icon/Icon.mjs";
const D = ({ ...t }) => /* @__PURE__ */ o(i.Root, { "data-slot": "accordion", ...t });
function H({ className: t, ...r }) {
  return /* @__PURE__ */ o(
    i.Item,
    {
      "data-slot": "accordion-item",
      className: e("border-b last:border-b-0", t),
      ...r
    }
  );
}
function P({ className: t, iconClassName: r, children: n, ...a }) {
  return /* @__PURE__ */ o(i.Header, { children: /* @__PURE__ */ s(
    i.Trigger,
    {
      "data-slot": "accordion-trigger",
      className: e(
        "focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 flex flex-1 items-start justify-between gap-4 text-left hover:cursor-pointer transition-all outline-none disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180",
        t
      ),
      ...a,
      children: [
        n,
        /* @__PURE__ */ o(
          c,
          {
            name: "chevronDown",
            className: e(
              "pointer-events-none size-3 translate-y-0.5 transition-transform duration-200",
              r
            )
          }
        )
      ]
    }
  ) });
}
function k({ className: t, children: r, ...n }) {
  return /* @__PURE__ */ o(
    i.Content,
    {
      "data-slot": "accordion-content",
      className: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm",
      ...n,
      children: /* @__PURE__ */ o("div", { className: e("", t), children: r })
    }
  );
}
export {
  k as AccordionContent,
  H as AccordionItem,
  D as AccordionRoot,
  P as AccordionTrigger
};
